/**
 * 房间业务
 */
import React, { useContext, useEffect, useState } from 'react';
import intl from 'react-intl-universal';

import { parseFen2Yuan, Calculator } from '@/utils/number';
import { DrawerContext, BillIncomeInfo, PaymentChannelInfo } from '@/pages/handover/helper';
import { fetchHandoverRoomReport } from '@/api/handover';
import { getCdnHost } from '@/config/apiHosts';

import IndicatorList, { IndicatorItem } from '../IndicatorList';
import BillIncomeTable from '../BillIncomeTable';
import BillChannelTable from '../BillChannelTable';

interface ReportData {
  baseBusIncomeMsgDTO: BillIncomeInfo[];
  baseBusPaymentTypeMsgDTOS: PaymentChannelInfo[];
  orderNum: number;
  indicatorList: IndicatorItem[];
}

const Index = () => {
  const { setLoadingStatus, handoverId } = useContext(DrawerContext);
  const [reportData, setReportData] = useState<ReportData>({} as ReportData);

  const getData = async () => {
    setLoadingStatus(true);
    try {
      const res = await fetchHandoverRoomReport({ id: handoverId });
      const { baseBusIncomeMsgDTO, baseBusPaymentTypeMsgDTOS } = res.data as ReportData;
      const incomeTotal = new Calculator(0);
      const refundAndIncome = new Calculator(0);
      (baseBusIncomeMsgDTO || []).forEach((item) => {
        incomeTotal.plus(item.income || 0);
      });
      (baseBusPaymentTypeMsgDTOS || []).forEach((item) => {
        refundAndIncome.plus(item.income || 0).minus(item.refund || 0);
      });
      setReportData({
        ...res.data,
        indicatorList: [
          // 营收合计：营收数据合计
          {
            name: intl.get('handover_room_indicator_income'),
            label: intl.get('handover_room_indicator_income'),
            icon: `${getCdnHost()}/image/common/20230403/165810067-handover_business_total.png`,
            iconHeight: 42,
            content: parseFen2Yuan(incomeTotal.getValue()),
          },
          // 收退款合计: 渠道收退款合计
          {
            name: intl.get('handover_room_indicator_refund'),
            label: intl.get('handover_room_indicator_refund'),
            icon: `${getCdnHost()}/image/common/20230403/165810129-handover_income_refund.png`,
            iconHeight: 32,
            content: parseFen2Yuan(refundAndIncome.getValue()),
          },
          // 预收款合计：收退款合计 - 营收合计
          {
            name: intl.get('handover_room_indicator_total'),
            label: intl.get('handover_room_indicator_total'),
            icon: `${getCdnHost()}/image/common/20230403/165810133-handover_income_total.png`,
            iconHeight: 40,
            content: parseFen2Yuan(refundAndIncome.minus(incomeTotal.getValue()).getValue()),
          },
        ],
      });
    } catch (e) {
      //
    }
    setLoadingStatus(false);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <IndicatorList items={reportData.indicatorList} />
      <BillIncomeTable type="Room" dataSource={reportData.baseBusIncomeMsgDTO} />
      <BillChannelTable dataSource={reportData.baseBusPaymentTypeMsgDTOS} />
    </div>
  );
};

export default Index;
